/**
 * *Done · <title>* — Board 9 C's toast: 470 wide, dark, a green tick, what it
 * was also on, and **Undo**. It goes by itself after eight seconds — not
 * while the pointer is on it — or on Esc.
 */
import { useEffect, useRef } from 'react'
import { cn } from '../../lib/cn.js'
import { usePhone } from '../../lib/use-narrow.js'
import { Glyph } from '../glyphs.js'

const STAYS_MS = 8_000

export function DoneToast({
  title, sub, onUndo, onDismiss,
}: { title: string; sub: string | null; onUndo: () => void; onDismiss: () => void }) {
  const phone = usePhone()
  const timer = useRef<number | null>(null)
  const start = () => {
    if (timer.current !== null) window.clearTimeout(timer.current)
    timer.current = window.setTimeout(onDismiss, STAYS_MS)
  }
  const hold = () => {
    if (timer.current !== null) window.clearTimeout(timer.current)
    timer.current = null
  }
  useEffect(() => {
    start()
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onDismiss() }
    window.addEventListener('keydown', onKey)
    return () => { hold(); window.removeEventListener('keydown', onKey) }
    /* A new toast is a new mount: the title is its key. */
  }, [title])

  return (
    <div role="status" onPointerEnter={hold} onPointerLeave={start}
      className={cn('fixed z-[70] flex items-center gap-3 rounded-xl bg-toast py-3 pl-4 pr-3.5 text-toast-text',
        'shadow-[0_14px_34px_rgba(20,20,10,.28)]',
        phone ? 'inset-x-3 bottom-[calc(18px+var(--activity-foot,0px))]' : 'bottom-6 left-1/2 w-[470px] max-w-[calc(100vw-24px)] -translate-x-1/2')}>
      <span className="inline-flex shrink-0 text-toast-accent"><Glyph name="circle_check" size={18} /></span>
      <div className="flex min-w-0 flex-col">
        <b className="truncate text-[13.5px] font-bold">{title}</b>
        {sub && <span className="truncate text-[12px] text-toast-muted">{sub}</span>}
      </div>
      <span className="flex-1" />
      <button type="button" onClick={onUndo}
        className="inline-flex h-[30px] shrink-0 items-center whitespace-nowrap rounded-lg border border-toast-line px-2.5 text-[12.5px] font-semibold text-toast-text hover:bg-toast-text/10">
        Undo
      </button>
    </div>
  )
}
